import { render, staticRenderFns } from "./paperCover.vue?vue&type=template&id=2c5197c6&scoped=true&"
import script from "./paperCover.vue?vue&type=script&lang=js&"
export * from "./paperCover.vue?vue&type=script&lang=js&"
import style0 from "./paperCover.vue?vue&type=style&index=0&id=2c5197c6&prod&scoped=true&lang=css&"
import style1 from "./paperCover.vue?vue&type=style&index=1&id=2c5197c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5197c6",
  null
  
)

export default component.exports